import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { MaterialesService } from './../../../../../../../../services/API/materiales/materiales.service';

@Component({
    selector: 'app-new-registro',
    templateUrl: './new-registro.component.html',
    styleUrls: ['./new-registro.component.css'],
    standalone: false
})
export class NewRegistroComponent implements OnInit {

  form: UntypedFormGroup;
  showProgressBar: boolean = true;
  materiales: any = [];
  material: number;
  observaciones: string = "";
  peso: string = "";
  foto1: any;
  foto1_base64: any;
  foto2: any;
  foto2_base64: any;

  constructor(private fb: UntypedFormBuilder, private materialesService:MaterialesService, private dialogRef: MatDialogRef<NewRegistroComponent>) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      material: [this.material, [Validators.required]],
      peso: [this.peso, [Validators.required, Validators.pattern("^[0-9]*$")]],
      observaciones: [this.observaciones, [Validators.maxLength(512)]],
      foto1: [this.foto1],
      foto2: [this.foto2],
    });

    this.getMateriales();
  }

  getMateriales() {
    this.showProgressBar = true;
    this.materialesService.getMateriales('Clasificacion').subscribe(result => {
      this.showProgressBar = false;
      this.materiales = result;
    });
  }

  save() {
    this.processFoto1();
  }

  processFoto1() {
    if(this.form.get('foto1').value !== null){
      const file = this.form.get('foto1').value;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (async () => {
        this.foto1_base64 = reader.result;
        this.processFoto2();
      });
    }else{
      this.processFoto2();
    }
  }

  processFoto2() {
    if(this.form.get('foto2').value !== null){
      const file1 = this.form.get('foto2').value;
      const reader1 = new FileReader();
      reader1.readAsDataURL(file1);
      reader1.onload = () => {
        this.foto2_base64 = reader1.result;
        this.sendForm();
      };
    }else{
      this.sendForm();
    }
  }

  sendForm() {
    const {value, valid} = this.form;
    if(valid){
      Object.assign(value, {"foto1": this.foto1_base64, "foto2": this.foto2_base64});
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }

  onFileSelected(event: Event, controlName: 'foto1' | 'foto2') {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length > 0 ? input.files[0] : null;
    this.form.get(controlName)?.setValue(file);
    this.form.get(controlName)?.markAsDirty();
    this.form.get(controlName)?.updateValueAndValidity();
  }

}
